<template>
  <div class="o-layer o-layer--medium">
    <div class="o-retain o-retain--wall">
      <div class="o-layout o-layout--gutter-base o-layout--align-middle">
        <div class="o-layout__cell o-layout__cell--fill">
          <UnitsHeader :rentalOutside="isRentalOutside" :complex="isComplex" />
        </div>
        <div
          class="o-layout__cell o-layout__cell--fit u-module u-margin-bottom"
        >
          <div class="c-form-field u-margin-bottom">
            <label class="c-label u-visually-hidden" for="showmap">
              <span class="c-label__label">{{ $label('toggleMap') }}</span>
            </label>
            <div class="c-form-field__control">
              <label
                class="c-input-control"
                for="showmap"
                @click.prevent="toggleMap"
              >
                <input
                  id="showmap"
                  name="showmap"
                  class="c-input-control__input u-visually-hidden"
                  type="checkbox"
                  :checked="isMapVisible"
                />
                <span class="c-input-control__indicator"></span>

                <span class="c-input-control__toggle" hidden>
                  <span class="c-input-control__toggle-btn">
                    <span class="c-input-control__icon-cross">
                      <Icon icon="cross" />
                    </span>
                    <span class="c-input-control__icon-check">
                      <Icon icon="checkmark" />
                    </span>
                  </span>
                </span>
                <span class="c-input-control__label">
                  {{ $label('toggleMap') }}
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="o-layout__cell o-layout__cell--fit">
          <div class="c-select u-margin-bottom">
            <label class="c-select__label" for="sortResults">
              {{ $label('sortByLabel') }}
            </label>
            <select
              class="c-input-text c-select__element c-select__element--mini c-select__element--fixedsize"
              name="sortResults"
              id="sortResults"
              v-model="sortType"
            >
              <option
                v-for="option in sortTypes"
                :key="option.key"
                :value="option.key"
                :selected="option.selected"
                v-html="option.label"
              ></option>
            </select>
            <div class="c-select__wrap-icon">
              <Icon icon="arrow-down" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from '@/components/Utilities/Icon'
import UnitsHeader from '@/components/Listing/UnitsHeader.vue'

export default {
  name: 'SortingHeader',
  components: { Icon, UnitsHeader },
  computed: Object.assign(mapGetters(['units']), {
    isMapVisible() {
      return this.$store.state.mapVisible
    },
    sortTypes() {
      return this.$store.state.sortTypes
    },
    sortType: {
      get() {
        return this.$store.state.filter.sorting
      },
      set(value) {
        this.$store.commit('UPDATE_SORT_TYPE', value)
        this.$store.dispatch('getUnits')
        localStorage.setItem('sortChange',1);
      },
    },
    isRentalOutside() {
      return (
        this.units?.objectsCount === 0 &&
        this.units?.objectsOutsideDistanceCount > 0
      )
    },
    isComplex() {
      return this.units?.objectsCount === 0 && this.units?.complexesCount > 0
    },
  }),
  methods: {
    toggleMap() {
      if (this.isMapVisible === false) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'action',
          eventCategory: 'search',
          eventAction: 'toon_op_kaart',
        })
      }
      this.$store.dispatch('toggleMap')
    },
  },
}
</script>
